<template>
  <div class="schedule-inner">
    <div class="schedule-heading">
      <h2>Post Schedule</h2>
      <!--
      <h2 v-if="isMaster">Posting Dates &amp; Times</h2>
      <h2 v-else>Posting Date &amp; Time</h2>
      -->
    </div>
    <div class="schedule-content">

      <div class="date-time-group-list" v-if="isMaster">
        <!-- Series Schedule -->

        <div class="date-time-group today" v-if="todayPosts">
          <h3>Today</h3>
          <SocialSummaryPostList :posts="todayPosts" />
        </div>

        <div class="date-time-group upcoming" v-if="upcomingPosts">
          <b-button v-b-toggle.upcoming-posts-collapse class="date-time-group-toggle">
            <i class="fas fa-chevron-right collapse-indicator"></i><h3>Upcoming Posts</h3>
          </b-button>
          <b-collapse id="upcoming-posts-collapse" v-model="showUpcomingPosts">
         		 <SocialSummaryPostList :posts="upcomingPosts" />
          </b-collapse>
        </div>


        <div class="date-time-group past" v-if="pastPosts">
        	<b-button v-b-toggle.past-posts-collapse class="date-time-group-toggle">
            <i class="fas fa-chevron-right collapse-indicator"></i><h3>Past Posts</h3>
          </b-button>
          <b-collapse id="past-posts-collapse" v-model="showPastPosts">
            <SocialSummaryPostList :posts="pastPosts" />
          </b-collapse>
        </div>

        <div class="date-time-single-inner no-date" v-if="!todayPosts && !upcomingPosts && !pastPosts">
          <h4>No Publish Date Set</h4>
        </div>
      </div>
      
      <!-- Single Deliverable -->
      <div class="date-time-single" v-else>
        <h3 v-if="todayPostSingle">Today</h3>
        <h3 v-if="upcomingPostSingle">Upcoming Post</h3>
        <h3 v-if="pastPostSingle">Past Post</h3>
        <SocialSummaryPostList :posts="[deliverable]" />
      </div>
      
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

import SocialSummaryPostList from "./SocialSummaryPostList.vue";
import SocialStatusLabel from "./SocialStatusLabel.vue"

export default{
  data() {
    return {
      dateFormat: "ddd, MMM D YYYY @ h:mm a",
      showPastPosts: false,
      showUpcomingPosts: false,
    }
  },
  props: ['deliverable'],
  components: {
    SocialStatusLabel,
    SocialSummaryPostList,
  },
  computed: {
    ...mapGetters([
    "systemSettings",
    "userAbilities",
    ]),
    isMaster(){
      if(this.deliverable.is_master === 1){
        return true;
      }
      return false;
    },
    masterId(){
      let series = this.deliverable.social_series_deliverables;
      if (series) {
	      if(series.length){
	        let master = series.find(x => x.is_master === 1);
	        if(master){
	          return master.id;
	        }
	      }
	    }
      return false;
    },
    todayPosts(){
      let that = this;
      let posts = this.deliverable.social_series_deliverables.filter(function(post){
        let today = that.$moment();
        if(today.isSame(that.$moment.utc(post.publish_date).local(), 'day')){
          return true;
        }
        return false;
      });
      if(posts.length){
        return posts;
      }
      return false;
    },
    upcomingPosts(){
      let that = this;
      let posts = this.deliverable.social_series_deliverables.filter(function(post){
        let today = that.$moment();
        if(today.isBefore(that.$moment.utc(post.publish_date).local(), 'day')){
          return true;
        }
        return false;
      });
      if(posts.length){
        return posts;
      }
      return false;
    },
    pastPosts(){
      let that = this;
      let posts = this.deliverable.social_series_deliverables.filter(function(post){
        let today = that.$moment();
        if(today.isAfter(that.$moment.utc(post.publish_date).local(), 'day')){
          return true;
        }
        return false;
      });
      if(posts.length){
        return posts;
      }
      return false;
    },
    todayPostSingle(){
      let today = this.$moment();
      if(today.isSame(this.$moment.utc(this.deliverable.publish_date).local(), 'day')){
        return [this.deliverable];
        return true;
      }
      return false;
    },
    upcomingPostSingle(){
      let today = this.$moment();
      if(today.isBefore(this.$moment.utc(this.deliverable.publish_date).local(), 'day')){
        return [this.deliverable];
        return true;
      }
      return false;
    },
    pastPostSingle(){
      let today = this.$moment();
      if(today.isAfter(this.$moment.utc(this.deliverable.publish_date).local(), 'day')){
        return [this.deliverable];
        return true;
      }
      return false;
    },
    
  },
  methods: {
    displayPublishDate(post){
      if(post){
        //let date = this.$moment.utc(seriesPost.publish_date).local().format("MMMM Do YYYY, h:mm a");
        let date = this.$moment.utc(post.publish_date).local().format(this.dateFormat);
        if(date == "Invalid date"){
          return "No date set";
        }
        return date;
      }
    },
  },
  created(){
    
  }
}
</script>